export const getRoutePermissions = (user) => {
  const role = user?.roles?.[0] || user?.roles || {}; 
  const userRole = Number(user?.role);

  return {
    "/dashboard": [0, 1, 2, 3],
    "/orders": role?.view_orders === 1 ? [0, 1, 2, 3, 4] : [0, 1, 3, 4],
    "/orders/update": role?.update_order === 1 ? [0, 1, 2, 3, 4] : [0, 1, 3, 4],
    "/products":  role?.view_products === 1 ? [0, 1, 2] : [0, 1], 
    "/products/create": role?.add_product === 1 ? [1, 2] : [1],
    "/products/update": role?.edit_product === 1 ? [1, 2] : [1, 2],
    "/categories": role?.view_categories === 1 ? [0, 1, 2] : [0, 1],
    "/categories/update": role?.edit_category === 1 ? [1, 2] : [1],
    "/categories/create": role?.add_category === 1 ? [1, 2] : [1],
    "/variants": role?.view_variants === 1 ? [1, 2] : [1],
    "/variants/update": role?.edit_variant === 1 ? [1, 2] : [1],
    "/variants/create": role?.edit_variant === 1 ? [1, 2] : [1],
    "/cities": [0, 1, 2, 3],
    "/configs": role?.edit_config === 1 ? [1, 2] : [1],
    "/scan-ramassage": role?.scan_order === 1 ? [1, 2] : [1],
    "/scan-retour": role?.scan_order === 1 ? [1, 2] : [1],
    "/admins": [1],
    "/sallers": role?.view_saller === 1 ? [1, 2] : [1],
    "/confirmators": role?.view_confirmator === 1 ? [1, 2] : [1],
    "/fournisseurs": role?.view_fournisseurs === 1 ? [1, 2] : [1],
    "/fournisseurs/create": role?.add_fournisseur === 1 ? [1, 2] : [1],
    "/fournisseurs/update": role?.edit_fournisseur === 1 ? [1, 2] : [1],
    "/roles": [1],
    "/payments": [0, 3],
    "/payments/sallers":  role?.view_saller_invoices === 1 ? [1, 2] : [1],
    "/payments/confirmators": role?.view_confirmator_invoices === 1 ? [1, 2] : [1],
    "/payments/system": [1],
    "/payments/livreurs":  role?.view_livreur_invoices === 1 ? [1, 2] : [9],
    "/black-list": role?.view_blacklist === 1 ? [1, 2] : [1],
    "/integration/delivery": [1],
    "/integration/applications": [0],
    "/integration/apis": [0],
    "/reclamations": role?.view_reclamations === 1 ? [0, 1, 2, 3] : [0, 1, 3],
    "/annonces": role?.view_annonces === 1 ? [1, 2] : [1],
    "/annonces/create": role?.add_annonce === 1 ? [1, 2] : [1],
    "/annonces/update": role?.edit_annonce === 1 ? [1, 2] : [1],
    "/cart": [0, 1, 2, 3],
    "/profile": [0, 1, 2, 3, 4],
    "/users/create": role?.add_confirmator === 1 ? [1, 2] : [1],
    "/activity-logs": [1],
  };
};

export function hasRouteAccess(pathname, user) {
  if (!user) return false;
  
  const normalizedPath = pathname.endsWith("/") && pathname !== "/" 
    ? pathname.slice(0, -1)
    : pathname;

  const permissions = getRoutePermissions(user);
  const userRole = Number(user.role);

  // Check exact route
  if (permissions[normalizedPath]) {
    return permissions[normalizedPath].includes(userRole);
  }

  // Check nested routes
  const sortedRoutes = Object.entries(permissions).sort(
    (a, b) => b[0].length - a[0].length
  );

  for (const [route, roles] of sortedRoutes) {
    if (normalizedPath === route || normalizedPath.startsWith(route + "/")) {
      return roles.includes(userRole);
    }
  }

  return true;
}
